import { useEffect } from 'react';
import ScaffoldPage from '../_ScaffoldPage';
export default function PortfolioOptimizerPage() {
  useEffect(() => { document.title = 'Portfolio Optimizer — Efficient Frontier & Mean-Variance Analysis | Nuvport OS'; }, []);
  return <ScaffoldPage badge="PORTFOLIO OPTIMIZER" title="Build a better portfolio with mean-variance optimization." description="Plot your efficient frontier, maximize Sharpe ratio, and find the optimal allocation across up to 76 stocks — in seconds." canonical="/features/portfolio-optimizer" />;
}
